import { Checkbox, Label } from "@bigbinary/neeto-atoms";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import classNames from "classnames";
import { GripVertical } from "lucide-react";

const Item = ({
  column,
  hiddenColumns,
  checkboxProps,
  onToggle,
  isTableConfigurationFetching,
}) => {
  const { key, title } = column;
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
    isOver,
    over,
    active,
  } = useSortable({ id: key });

  const dragStyle = {
    transform: isDragging ? CSS.Transform.toString(transform) : undefined,
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  const isIndicatorVisible = !isDragging && isOver;
  const draggedIndex = active?.data?.current?.sortable?.index;
  const targetIndex = over?.data?.current?.sortable?.index;

  const isChecked = !hiddenColumns.includes(key);

  return (
    <div>
      <div
        className={classNames({
          "bg-muted h-1 w-full":
            isIndicatorVisible && targetIndex < draggedIndex,
        })}
      />
      <div
        className="hover:bg-accent relative flex items-center px-5 py-2"
        data-testid="column-sortable-item"
        ref={setNodeRef}
        style={dragStyle}
      >
        <div
          {...attributes}
          {...listeners}
          className="absolute top-1/2 left-0.5 flex -translate-y-1/2 cursor-grab items-center active:cursor-grabbing"
          data-testid="column-drag-handle"
        >
          <GripVertical
            className="text-muted-foreground/50 hover:text-foreground transition-all duration-300 ease-in-out"
            size={16}
          />
        </div>
        <Label
          className="flex w-full cursor-pointer items-center"
          htmlFor={key}
        >
          <Checkbox
            checked={isChecked}
            data-testid="neeto-ui-columns-checkbox"
            disabled={isTableConfigurationFetching}
            id={key}
            name={key}
            onCheckedChange={checked => {
              onToggle({ target: { name: key, checked } });
            }}
            {...checkboxProps}
          />
          <span className="ml-2 text-sm">{title}</span>
        </Label>
      </div>
      <div
        className={classNames({
          "bg-muted h-1 w-full":
            isIndicatorVisible && targetIndex > draggedIndex,
        })}
      />
    </div>
  );
};

export default Item;
